module.exports = __webpack_public_path__ + "img/10.b8295026.png";